import React from 'react';
import {
  Switch,
  Route,
  useRouteMatch,
} from 'react-router-dom';

import {
  PagePicsList,
  PagePic,
} from '../pages/pics';

const RoutePics = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <PagePicsList />
      </Route>
      <Route path={`${path}/:_id`}>
        <PagePic />
      </Route>
    </Switch>
  );
};

export default RoutePics;
